import { AnnualReviewMarketInfo, highlightMarket } from '../../lib/collections/posts/annualReviewMarkets';
import React, { useMemo } from 'react';
import { useHover } from '../common/withHover';
import { highlightReviewWinnerThresholdSetting } from '@/lib/instanceSettings';
import { tagStyle } from '../tagging/FooterTag';
import { Card } from "@/components/widgets/Paper";
import HoverOver from "../common/HoverOver";
import ContentStyles from "../common/ContentStyles";
import { defineStyles } from '@/components/hooks/defineStyles';
import { useStyles } from '@/components/hooks/useStyles';
import HoverPreviewLink from '@/components/linkPreview/HoverPreviewLink';
import { Link } from '@/lib/reactRouterWrapper';

const sharedStyles = (theme: ThemeType) => ({
  width: 'fit-content',
  display: 'inline-block',
  padding: '5px',
  boxSizing: 'border-box',
  paddingLeft: 6,
  paddingRight: 6,
  fontWeight: theme.typography.body1.fontWeight,
  ...theme.typography.commentStyle,
  cursor: "pointer"
})

const styles = defineStyles('PostsAnnualReviewMarketTag', (theme: ThemeType) => ({
  expectedWinner: {
    ...sharedStyles(theme),
    color: theme.palette.review.winner,
    border: '1px solid',
    borderColor: theme.palette.review.winner,
    borderRadius: '4px',
  },
  expectedLoser: {
    ...sharedStyles(theme),
    color: theme.palette.tag.text,
  },
  preview: {
    maxWidth: 400,
  },
  card: {
    padding: 16,
    width: 450,
    paddingTop: 8,
  },
  manifoldIframe: {
    height: 405,
    width: '100%',
    border: 'none',
  },
}));

const PostsAnnualReviewMarketTag = ({annualReviewMarketInfo}: {
  annualReviewMarketInfo: AnnualReviewMarketInfo,
}) => {
  const classes = useStyles(styles);
  const { anchorEl, hover, eventHandlers } = useHover();

  const year = annualReviewMarketInfo.year
  const marketUrl = annualReviewMarketInfo.url
  const marketLongSlug = useMemo(() => {
    const [, userAndSlug] = marketUrl.match(/^https?:\/\/manifold\.markets\/(\w+\/[\w-]+)/) || [];
    return userAndSlug;
  }, [marketUrl]);

  const marketOutcomeClass = (highlightMarket(annualReviewMarketInfo)) ? "expectedWinner" : "expectedLoser"

  const decimalPlaces = 0;
  return <span>
    <div className={classes[marketOutcomeClass]} {...eventHandlers}>
      {<HoverOver
          title={
            <Card className={classes.card}>
              <ContentStyles contentType="comment">
                <p>
                  <HoverPreviewLink href={marketUrl}>
                    Will this post make the top fifty of the {year+1} Annual Review?
                  </HoverPreviewLink>
                </p>
                <p>
                  The <Link to="/bestoflesswrong">LessWrong Review</Link> runs every year to select the posts that have most stood the test of time. This post is not yet eligible for review, but will be at the end of {year+1}. The top fifty or so posts are featured prominently on the site throughout the year.
                </p>
                <p>
                  Hopefully, the review is better than karma at judging enduring value. If we have accurate prediction markets on the review results, maybe we can have better incentives on LessWrong today.
                </p>
                <div data-manifold-id={marketLongSlug} className="manifold-preview">
                  <iframe
                    className={classes.manifoldIframe}
                    src={`https://manifold.markets/embed/${marketLongSlug}`}
                  />
                </div>
              </ContentStyles>
            </Card>
          }
          tooltip={false}
          clickable={true}
        >
        <a href={marketUrl} className={classes.preview}>
          {annualReviewMarketInfo.year} Top Fifty: {parseFloat((annualReviewMarketInfo.probability * 100).toFixed(decimalPlaces))}%
        </a>
      </HoverOver>
      }
    </div>
  </span>
};

export default PostsAnnualReviewMarketTag


